import { createSlice } from "@reduxjs/toolkit";
import { getCartValueFromJob } from "../../utils/jobUtils";
const initialState = {
    job_id: "",
    draft_id: "",
    media_path: {
        path: "",
        raw_path: ""
    },
    title: "",
    service_lst: [],
    service: [],
    preferences_obj: [],
    base_preferences_obj: [],
    preferences_lst: [],
    base_preferences_lst: [],
    media: [],
    output_file_count: 0,
    notes: "",
    turn_around_time: 0,
    summary: {},
    price: 0,
    gross_price: 0.00,
    cart_value: 0.00,
    net_price: 0.00,
    discount: 0.00,
    is_user_preference_applied: false,
    coupon_code: '',
    user_id: 0,
};

const jobSlice = createSlice({
    name: 'job',
    initialState,
    reducers: {
        resetJob: () => {
            return { ...initialState }
        },
        updateJob: (state, action) => {
            let tempJob = { ...state, ...action.payload }
            return { ...tempJob, cart_value: getCartValueFromJob(tempJob) }
        },
        updateDraftId: (state, action) => {
            state.draft_id = action.payload
        },
        updateMediaPath: (state, action) => {
            state.media_path = action.payload
        },
        updateUserId: (state, action) => {
            state.user_id = action.payload
        },
        updateJobId: (state, action) => {
            state.job_id = state.job_id ? state.job_id : action.payload
        },
        updateJobName: (state, action) => {
            state.title = action.payload
        },
        updateOutputFileCount: (state, action) => {
            state.output_file_count = action.payload
        },
        updateService: (state, action) => {
            state.service_lst = [action.payload.id]
            state.service[0] = action.payload
            state.preferences_obj = []
            state.preferences_lst = []
            state.base_preferences_obj = []
            state.base_preferences_lst = []
            state.is_user_preference_applied = false
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },
        addPreferencesLst: (state, action) => {
            if (!state.preferences_lst.includes(action.payload.preference_id)) {
                state.preferences_lst.push(action.payload.preference_id)
                state.preferences_obj.push(action.payload)
            }
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },
        removePreferencesLst: (state, action) => {
            const indexValueOfpreference = state.preferences_obj.findIndex(preference => preference.preference_id === action.payload.preference_id)
            if (indexValueOfpreference >= 0) {
                state.preferences_obj.splice(indexValueOfpreference, 1)
            }
            const indexValueOfPreferenceId = state.preferences_lst.indexOf(action.payload.preference_id)
            if (indexValueOfPreferenceId >= 0) {
                state.preferences_lst.splice(indexValueOfPreferenceId, 1)
            }
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },

        setDefaultBasePreferences: (state, action) => {
            action.payload.forEach((preference => {
                if (!state.base_preferences_lst.includes(preference.id)) {
                    state.base_preferences_obj.push(preference)
                    state.base_preferences_lst.push(preference.id)
                }
                state.summary = {}
                state.cart_value = getCartValueFromJob(state)
            }))
        },
        addBasePreferencesLst: (state, action) => {
            if (!state.base_preferences_lst.includes(action.payload.id)) {
                state.base_preferences_obj.push(action.payload)
                state.base_preferences_lst.push(action.payload.id)
            }
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },
        removeBasePreferencesLst: (state, action) => {
            let indexValueOfBasePreferenceId = state.base_preferences_lst.indexOf(action.payload.id)
            if (indexValueOfBasePreferenceId >= 0) {
                state.base_preferences_lst.splice(indexValueOfBasePreferenceId, 1)
            }
            let indexValue = state.base_preferences_obj.findIndex(preference => preference.id === action.payload.id)
            if (indexValue >= 0) {
                state.base_preferences_obj.splice(indexValue, 1)
            }
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },
        updateNotes: (state, action) => {
            state.notes = action.payload
        },
        addHotspot: (state, action) => {
            state.media[action.payload.mediaIndex].hotspots.push(action.payload.hotspot)
        },
        addMedia: (state, action) => {
            state.media.push(action.payload)
            state.summary = {}
            state.cart_value = getCartValueFromJob(state)
        },
        removeMedia: (state, action) => {
            action.payload.forEach((deleteImg) => {
                const imgIndex = state.media.findIndex(img => img.name === deleteImg.name)
                if (imgIndex >= 0) {
                    state.media.splice(imgIndex, 1)
                    state.cart_value = getCartValueFromJob(state)
                }
            })
            state.summary = {}

        },
        setMedia: (state, action) => {
            state.media = action.payload
            state.summary = {}
        },
        updateMarkedImage: (state, action) => {
            state.media[action.payload.mediaIndex].marked_image = action.payload.markedimage
        },
        updateHotspot: (state, action) => {
            state.media[action.payload.mediaIndex].hotspots[action.payload.hotspotIndex].text = action.payload.hotspotText
        },
        removeHotspot: (state, action) => {
            state.media[action.payload.mediaIndex].hotspots.splice(action.payload.hotspotIndex, 1)
        },
        removeAllHotspotByIndex: (state, action) => {
            state.media[action.payload].hotspots = []
        },
        updateTurnAround: (state, action) => {
            state.turn_around_time = action.payload
        },
        addSummary: (state, action) => {
            state.summary = action.payload
            state.cart_value = getCartValueFromJob(state)
        },
        addCouponCode: (state, action) => {
            state.coupon_code = action.payload
            state.cart_value = getCartValueFromJob(state)
        },
        setCartValue: (state, action) => {
            state.cart_value = action.payload
        },
        setIsUserPreferenceApplied: (state, action) => {
            state.is_user_preference_applied = action.payload
        },
        resetBilling: (state, action) => {
            state.summary = {}
            state.turn_around_time = 0
            state.price = 0
            state.gross_price = 0
            state.net_price = 0
            state.discount = 0
            state.coupon_code = ""
            state.cart_value = getCartValueFromJob(state)
        }
    }
});

export const jobActions = jobSlice.actions;

export default jobSlice;